module.exports = __webpack_public_path__ + "img/biogen_logo.1ab34929.png";